import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AbstractService } from "app/services/abstract.service";
import { environment } from "environments/environment.prod";
import { VisitGps } from "./dto/visit-gps.interface";
import { Observable } from "rxjs";

const apiUrl = environment.AP_GPS_URL;
const moduleName = 'gps';

@Injectable({
  providedIn: "root",
})
export class VisitGpsService extends AbstractService<
  VisitGps,
  VisitGps,
  VisitGps
> {

  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  getListReplicas(data) : Observable<VisitGps[]> {
    let params = new HttpParams();

    if (data.date) {
      params = params.set("date", data.date);
    }

    if (data.userid) {
      params = params.set("userId", data.userid);
    }

    if (data.limit) {
      params = params.set("limit", data.limit);
    }

    const API_URL: string = apiUrl + `api/${moduleName}/last_records_by_user_id`;
    return this.http.get<VisitGps[]>(API_URL, { params: params });
  }
}
